<div
  class="container-fluid justify-content-center mb-0 pt-1 pb-2 pb-md-0 shadow-lg col-12"
>
  <div class="jumbotron-fluid mx-0 px-0 mt-1 pt-2 mb-0 pb-0">
    <div class="container mt-2 mb-1 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Create Regions, Towns, Stations
          </h3>
        </div>
      </div>
    </div>
    <div class="container mx-0 px-0 mb-0 pb-1">
      <div class="d-flex justify-content-start my-0 pt-2 pb-0 mx-0 px-0">
        <div class="col-12 mx-0 px-0">
          <a routerLink="createregion"
            ><button class="btn btn-info ml-1 mr-0 px-1">Create Region</button>
          </a>
          <a routerLink="createtown"
            ><button class="btn btn-info ml-1 mr-0 px-1">Create Town</button>
          </a>
          <a routerLink="createstation"
            ><button class="btn btn-info ml-1 mr-0 px-1">
              Create Station
            </button></a
          >
        </div>
        <!-- <div class="col-2 mx-0 px-0">
          <div ngbDropdown class="d-inline-block mx-0 px-0">
            <button
              class="btn btn-info mx-0 px-2"
              id="dropdownBasic1"
              tooltip="Created Areas"
              ngbDropdownToggle
            >
              <i class="fas fa-eye"></i> View
            </button>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownBasic1"
              class="dropdown-menu"
            >
              <button ngbDropdownItem>Regions</button>
              <button ngbDropdownItem>Towns</button>
              <button ngbDropdownItem>Stations</button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
